// Starter workspace for the "New empty project" menu action: the two
// files every ArchLang workspace needs — a `package.archspace` that
// pulls in the pragmatic backend vocabulary, and a single `.arch` file
// with one service to edit from. Deliberately minimal: a blank canvas,
// not a demo.
import { buildWorkspaceFromEntries, type LoadedSources } from "./sourceLoader";

const ARCHSPACE = `package: my.project
version: "0.1.0"

// Pull in the pragmatic backend vocabulary (service / database /
// cache / http / rest / grpc / kafka …). Stdlib \`arch.*\` packages
// resolve automatically — no \`dependencies\` entry needed.
use * from arch.backend
`;

const ARCH = `// Your first module. Edit freely.
service MyService {
    "What this service does."
}
`;

/** Build the blank two-file starter workspace. */
export function emptyProjectSources(): LoadedSources {
  return buildWorkspaceFromEntries(
    [
      { path: "package.archspace", content: ARCHSPACE },
      { path: "main.arch", content: ARCH },
    ],
    { label: "Empty project" },
  );
}
